<template>
  <div class="global-search-container">
    <div class="container-tabs">
      <n-tabs size="large" :value="activeTabs" @update:value="handTabsClick">
        <n-tab-pane name="" tab="All"> </n-tab-pane>
        <n-tab-pane v-for="tab in tabs" :key="tab" :name="tab" :tab="tab"> </n-tab-pane>
      </n-tabs>
    </div>
    <div v-if="!list.length" class="no-data">
      <n-empty description="No Data"> </n-empty>
    </div>
    <div v-else class="search-list">
      <div v-for="(item, index) in list" :key="index" class="search-list-item" @click="gotoLink(item.hyperlink)">
        <div v-dompurify-html="item?.highlightFields?.title?.[0] || item.title" class="search-list-title"></div>
        <div v-dompurify-html="item?.highlightFields?.content?.[0]" class="search-list-desc"></div>
        <div class="search-list-link">
          {{ origin + '/#' + item.hyperlink }}
        </div>
      </div>
    </div>

    <div v-if="list.length" class="list-pagination">
      <n-pagination
        :page="pagination.page"
        :item-count="pagination.itemCount"
        show-size-picker
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="pagination.pageSize"
        :prefix="({ itemCount }) => `Total is ${itemCount}`"
        @update:page="handlePageChange"
        @update:page-size="handlePageSizeChange"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, defineProps, defineExpose, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

import { fetchMoudelNames, fetchSearchList, fetchllmQuery } from '@/api/search';

const props = defineProps({
  inputValue: {
    default: '',
    type: String,
  },
});

const pagination = ref({
  page: 1,
  pageSize: 5,
  itemCount: 0,
});

const origin = ref(location.origin);

const route = useRoute();
const list = ref([]);
const loading = ref(false);
const tabs = ref([]);
const activeTabs = ref('');
// const query = ref(route.query?.searchValue);

const getModuleNames = async () => {
  const data = await fetchMoudelNames({});
  tabs.value = data;
};

const handlePageChange = (pageNo: number) => {
  pagination.value.page = pageNo;
  getSearchList();
};
const handlePageSizeChange = (value: any) => {
  pagination.value.pageSize = value;
  getSearchList();
};

const handTabsClick = (value: any) => {
  activeTabs.value = value;
  searchHanlder();
};

const searchHanlder = () => {
  pagination.value.page = 1;
  getSearchList();
  // fetchAImodle();
};

const getSearchList = async () => {
  try {
    loading.value = true;
    const payload = {
      searchSocpe: activeTabs.value,
      keyword: props.inputValue,
      current: pagination.value.page,
      size: pagination.value.pageSize,
    };
    const data = await fetchSearchList(payload);
    list.value = data.records;
    // console.log(list);
    pagination.value.itemCount = data.total;
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};

const gotoLink = (link: string) => {
  window.open(location.origin + '/#' + link);
};
onMounted(() => {
  getModuleNames();
});
defineExpose({
  searchHanlder,
});
</script>

<style lang="scss" scoped>
.global-search-container {
  margin: 0 !important;
  overflow-y: auto;
  height: 100%;
  .container-tabs {
    padding: 0 32px;
  }

  .no-data {
    min-height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .search-list {
    // min-height: 420px;
    min-height: calc(100% - 130px);
    max-height: calc(100% - 130px);
    overflow-y: auto;
    margin-bottom: 20px;
    padding: 0 20px;
    .search-list-item {
      background: #fff;
      padding: 20px;
      margin-bottom: 20px;
      cursor: pointer;
      border-radius: 20px;
    }
    .search-list-title {
      font-weight: 400;
      font-size: 20px;
      line-height: 27px;

      color: #262626;
    }
    .search-list-desc {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      word-break: break-all;
      color: #666;
    }
    .search-list-link {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;

      color: #572df3;
    }
  }

  .list-pagination {
    padding: 0 32px;
    display: flex;
    justify-content: right;
  }
}
</style>
